import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';
import sliderListCutFactory, { PublicVarsInterface as SliderListCutSetupInterface } from '../../../libs/slider/slider-list-cut';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsFsReportsReportsCls: string;
		}
	},

	reportsSliderListCutSetup?: SliderListCutSetupInterface,

	slug: string
}

class Reports extends Module {

	publicVars: OptionsInterface;

	service: {
		sliderReports: ReturnType<typeof sliderListCutFactory.create> | null,
	} = {
		sliderReports: null,
	}

	constructor(options: OptionsInterface) {
		super('Investors Financial Statements Reports Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		if(!this.publicVars.reportsSliderListCutSetup) {
			this.errorMsg('sliderSetup reports is not defined');
		} else {
			this.service.sliderReports = sliderListCutFactory.create();
			this.service.sliderReports.init(this.publicVars.reportsSliderListCutSetup);
		}

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsFsReportsReportsCls || '', 'investors_financial_statements_reports', { animCls: 'animate__fadeInDown50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Reports;